export default "__VITE_ASSET__D6Cf4ZsY__"